import { RpmMonitoringContentModel } from '../generated/types/RpmMonitoringContentModel';
import { RpmMonitoringContentMock } from '../generated/mocks/RpmMonitoringContentModelMock';

const defaultRpmMonitoringContentMock = RpmMonitoringContentMock
  .rpm_monitoring[0] as unknown as RpmMonitoringContentModel;

const exampleRpmMonitoringContentMock: RpmMonitoringContentModel = {
  metadata: {},
  title: 'title',
  rpm_tab: 'Remote patient monitoring',
  rpm_module: [
    {
      rpm_module: {
        metadata: {},
        algorithm_code: 'GI_TOX',
        header: 'Digestive symptoms',
        details_header: 'Digestive symptoms %{suffix}',
        disclaimer_md:
          'This remote patient monitoring solution only captures the following gastrointestinal symptoms: change in appetite, nausea, vomiting, and constipation, as well as symptoms associated with dehydration. This patient might experience additional symptoms that are not reported here. Please follow up with your patient if you would like to learn more about their symptoms. In the absence of medical follow up, this data does not constitute a reportable safety event.',
        learn_more: [
          {
            header_and_body: {
              metadata: {},
              header: '[M]rpm_module.rpm_module.learn_more.header_and_body.header',
              body_text_md: '[M]rpm_module.rpm_module.learn_more.header_and_body.body_text_md',
            },
          },
          {
            header_body_icon: {
              metadata: {},
              header: '[M]rpm_module.rpm_module.learn_more.header_body_icon.header',
              body_text: [
                {
                  body: {
                    metadata: {},
                    body_text_md: '[M]rpm_module.rpm_module.learn_more.header_body_icon.body_text.body.body_text_md',
                    icon: 'notification',
                  },
                },
              ],
            },
          },
        ],
        cards: [
          {
            card: {
              metadata: {},
              code: 'GI_TOX_CARD',
              charts: [
                {
                  chart: {
                    metadata: {},
                    title: 'rpm_module.rpm_module.cards.card.charts.chart.title',
                    code: 'GI_TOX_OVERVIEW_CHART',
                    not_reported_label: 'rpm_module.rpm_module.cards.card.charts.chart.not_reported_label',
                    parameters: [
                      {
                        metadata: {},
                        label: 'rpm_module.rpm_module.cards.card.charts.chart.parameters.label',
                        parameter: [
                          {
                            metadata: {},
                            title: 'rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.title',
                            code: 'APPETITE',
                            label: 'Change in appetite',
                            secondary_label: '',
                            tertiary_label: '',
                            tooltip_label: '',
                            details_label: '',
                            uid: 'APPETITE',
                            _content_type_uid: 'rpm_parameter',
                          },
                          {
                            metadata: {},
                            title: 'rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.title',
                            code: 'NAUSEA',
                            label: 'Nausea',
                            secondary_label: '',
                            tertiary_label: '',
                            tooltip_label: '',
                            details_label: '',
                            uid: 'NAUSEA',
                            _content_type_uid: 'rpm_parameter',
                          },
                          {
                            metadata: {},
                            title: 'rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.title',
                            code: 'VOMITING',
                            label: 'Vomiting',
                            secondary_label: '',
                            tertiary_label: '',
                            tooltip_label: '',
                            details_label: '',
                            uid: 'VOMITING',
                            _content_type_uid: 'rpm_parameter',
                          },
                          {
                            metadata: {},
                            title: 'rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.title',
                            code: 'CONSTIPATION',
                            label: 'Constipation',
                            secondary_label: '',
                            tertiary_label: '',
                            tooltip_label: '',
                            details_label: '',
                            uid: 'CONSTIPATION',
                            _content_type_uid: 'rpm_parameter',
                          },
                          {
                            metadata: {},
                            title: 'rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.title',
                            code: 'DIARRHEA',
                            label: 'Diarrhea',
                            secondary_label: '',
                            tertiary_label: '',
                            tooltip_label: '',
                            details_label: '',
                            uid: 'DIARRHEA',
                            _content_type_uid: 'rpm_parameter',
                          },
                          {
                            metadata: {},
                            title: 'rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.title',
                            code: 'NONE',
                            label: 'None',
                            secondary_label: '',
                            tertiary_label: '',
                            tooltip_label: '',
                            details_label: '',
                            uid: 'NONE',
                            _content_type_uid: 'rpm_parameter',
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  chart: {
                    metadata: {},
                    title: 'rpm_module.rpm_module.cards.card.charts.chart.title',
                    code: 'GI_TOX_MEDICATION_CHART',
                    not_reported_label: 'rpm_module.rpm_module.cards.card.charts.chart.not_reported_label',
                    parameters: [
                      {
                        metadata: {},
                        label: 'rpm_module.rpm_module.cards.card.charts.chart.parameters.label',
                        parameter: [
                          {
                            metadata: {},
                            title: 'rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.title',
                            code: 'MEDICATION',
                            label: 'Medication taken',
                            secondary_label: '',
                            tertiary_label: '',
                            tooltip_label: '',
                            details_label: '',
                            uid: 'MEDICATION',
                            _content_type_uid: 'rpm_parameter',
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      rpm_module: {
        metadata: {},
        algorithm_code: 'MARSDEN_WEIGHT_SCALE',
        header: 'Weight events',
        details_header: '',
        disclaimer_md: 'Disclaimer markdown for weight events',
        cards: [],
      },
    },
    {
      rpm_module: {
        metadata: {},
        algorithm_code: 'MIR_PEF',
        header: 'MIR PEF events',
        details_header: '',
        disclaimer_md: 'Disclaimer markdown for weight events',
        cards: [],
      },
    },
    {
      rpm_module: {
        metadata: {},
        algorithm_code: 'MASIMO_SPO2',
        header: 'Masimo SPO2 events',
        details_header: '',
        disclaimer_md: 'Disclaimer markdown for weight events',
        cards: [],
      },
    },
  ],
  study_day_label: 'D${studyDayNumber}',
  uid: 'uid',
  _content_type_uid: 'rpm_monitoring',
};

const create = (partial?: Partial<RpmMonitoringContentModel>): RpmMonitoringContentModel => ({
  ...defaultRpmMonitoringContentMock,
  ...exampleRpmMonitoringContentMock,
  ...partial,
});

export const RpmMonitoringContentModelMock = { create };
